import { IRequesterInfo } from '../../../../../base/models/proxyModels'
import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { SavePreOrderRequest, SavePreOrderResponse } from '../models/models'
export class SavePreOrderService extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({ url: 'admin/preOrder/savePreOrder', requesterInfo })
  }

  public async savePreOrder(request: SavePreOrderRequest): Promise<SavePreOrderResponse> {
    return await this.postAsync<SavePreOrderResponse>(request)
  }
}
